import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Table from '@material-ui/core/Table/index';
import TableBody from '@material-ui/core/TableBody/index';
import TableCell from '@material-ui/core/TableCell/index';
import TableHead from '@material-ui/core/TableHead/index';
import TableRow from '@material-ui/core/TableRow/index';
import Paper from '@material-ui/core/Paper/index';

import IconButton from "@material-ui/core/IconButton";
import DeleteOutlined from '@material-ui/icons/DeleteOutlined';
import ModalProveedor from "./ModalProveedor";
import {FieldsJs} from "../../../../settings/General/General";
import {ReactLocalStorageService} from '../../../../settings/ReactLocalStorageService/ReactLocalStorageService';
import Zoom from "@material-ui/core/Zoom";
import Tooltip from "@material-ui/core/Tooltip";
import {PopupService} from "../../../../settings/PoPup/PoPup";
import {ProveedorService} from "../../../../services/ProveedorService/ProveedorService";
import {CONFIG} from "../../../../settings/Config/Config";

class ListaTabla extends Component {
	
	Usr = {};
	
	constructor() {
		super();
		this.Usr = ReactLocalStorageService.get('Usr') || {};
	}
	
	eliminar = (item) => {
		let msg = `¿Deseas eliminar el proveedor ${item.razon_social}?`;
		PopupService.Confirm(['Cancelar', 'Eliminar'], 'warning', CONFIG.titulo_alert_confirm, msg).then((r) => {
			if (r.button === 'Eliminar') {
				ProveedorService.Eliminar(item.id_proveedor).then((response) => {
					this.props.showSnackBars('success', response.mensaje);
					this.props.RefreshList();
				}).catch((error) => {
					this.props.showSnackBars('error', error.mensaje);
				});
			}
		});
	};
	
	render() {
		
		const {lista} = this.props;
		
		return (
			<Paper>
				<Table className={'desing-acresco'}>
					<TableHead>
						<TableRow>
							<TableCell component="th" align={'left'}>Id</TableCell>
							<TableCell component="th" align={'left'}>Nombre comercial</TableCell>
							<TableCell component="th" align={'left'}>Razón social</TableCell>
							<TableCell component="th" className={'w-130-px'} align={'center'}>RFC</TableCell>
							<TableCell component="th" align={'center'}>Teléfono</TableCell>
							<TableCell component="th" align={'center'}>correo electrónico</TableCell>
							<TableCell component="th" align={'left'}>Pagina web</TableCell>
							<TableCell component="th" align={'center'}>Activo</TableCell>
							<TableCell component="th" align={'center'} className={'w-110-px'}>Acciones</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{lista.map((item, key) => (
							<TableRow key={key}>
								
								<TableCell align={'left'} className={'margin-20-L'}>
									{item.id_proveedor}
								</TableCell>
								
								<TableCell align={'left'}>
									{item.nombre_comercial}
								</TableCell>
								
								<TableCell align={'left'}>
									{item.razon_social}
								</TableCell>
								
								<TableCell align={'center'}>
									{item.rfc || '-'}
								</TableCell>
								
								<TableCell align={'center'}>
									{item.telefono || 'Sin telefono'}
								</TableCell>
								
								<TableCell align={'center'}>
									{item.correo_electronico || "-"}
								</TableCell>
								
								<TableCell align={'center'}>
									{item.pagina_web || "-"}
								</TableCell>
								
								<TableCell align={'center'}>
									{item.activo === 1 ? (
										<div style={{
											width: "50px",
											color: "white",
											borderRadius: "3px",
											padding: "2px 10px",
											background: "darkgreen",
											display: "inline-grid",
										}}>Activo</div>
									) : (
										<div style={{
											width: "50px",
											color: "white",
											borderRadius: "3px",
											padding: "2px 10px",
											background: "#901C30",
											display: "inline-grid",
										}}>Inactivo</div>
									)}
								</TableCell>
								
								<TableCell align={'center'} className={'padding-5-L padding-5-R'}>
									
									<div className={'w-auto vertical-inline'}>
										{FieldsJs.inArray([1, 2], this.Usr.id_cat_tipo_usuario) ? (
											<div className={'v-center'}>
												<Tooltip TransitionComponent={Zoom} placement={"top"} title="Eliminar">
													<IconButton aria-label="Eliminar" onClick={() => this.eliminar(item)}>
														<DeleteOutlined/>
													</IconButton>
												</Tooltip>
											</div>
										) : ''}
										{FieldsJs.inArray([1, 2], this.Usr.id_cat_tipo_usuario) ? (
											<div className={'v-center'}>
												<ModalProveedor
													id_proveedor={item.id_proveedor}
													tipo={'edit'}
													item={item}
													RefreshList={this.props.RefreshList}
													showSnackBars={this.props.showSnackBars}
												/>
											</div>
										) : ''}
										<div className={'v-center'}>
											<ModalProveedor
												id_proveedor={item.id_proveedor}
												tipo={'view'}
												item={item}
												RefreshList={this.props.RefreshList}
												showSnackBars={this.props.showSnackBars}
											/>
										</div>
									</div>
								
								</TableCell>
							
							</TableRow>
						))}
					</TableBody>
				</Table>
			</Paper>
		)
	}
}

ListaTabla.propTypes = {
	lista: PropTypes.array.isRequired,
	RefreshList: PropTypes.func.isRequired,
	showSnackBars: PropTypes.func.isRequired,
};

export default ListaTabla;
